// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AddNewBlock_wrap__qbhOJ","container":"AddNewBlock_container__owTXC","icon":"AddNewBlock_icon__AlaFa","text":"AddNewBlock_text__3UjO1"};